import common from "../../utill/Common";

class NoticeService {
  fetchAll = async (token) => {
    const url = common.baseUrl + "user/profile/fetch_carousel_slider_images";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: null,
    };

    const response = await fetch(url, options);

    return response.json();
  };

  fetchFlashMessage = async (token) => {
    const url = common.baseUrl + "user/profile/fetch_flash_message";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: null,
    };

    const response = await fetch(url, options);

    return response.json();
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new NoticeService();
